module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.f6d48c59.svg";